import { render, staticRenderFns } from "./TherapySendSchoolQuestionnaire.vue?vue&type=template&id=0c6cd4af"
import script from "./TherapySendSchoolQuestionnaire.vue?vue&type=script&lang=js"
export * from "./TherapySendSchoolQuestionnaire.vue?vue&type=script&lang=js"
import style0 from "./TherapySendSchoolQuestionnaire.vue?vue&type=style&index=0&id=0c6cd4af&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports